<template>
  <div class="gift-ideas">
    <div class="top-white-box"></div>
    <div class="top-gray-box">
        <h1>The Best Gift Buying Ideas</h1>
    </div>
    
    <Articles />
    
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed } from 'vue'
import Articles from '@/components/Articles.vue'
import settings from '@/settings'

export default defineComponent({
  name: 'giftideas',
  components: {
    Articles
  },
  setup() {
    onMounted(() => {
      document.title = 'The Best Gift Buying Ideas for Everyone On Your List | ' + settings.siteNameCaps
    })

    const settingsComputed = computed(() => settings)

    return {
      settings: settingsComputed
    }
  }
})
</script>